import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  CircularProgress,
  Avatar,
  Stack,
  Pagination,
  Box,
  Tooltip
} from '@mui/material';
import palette from 'src/theme/palette';
import { TableNoData } from 'src/components/NoData';
import { api } from 'src/Api';
import { toast } from 'react-toastify';
import { LoadingButton } from '@mui/lab';
import Iconify from 'src/components/Iconify';
import LoadingButtonWrapper from 'src/components/LoadingButtonWrapper';

const UploadListTable = ({ data, loading, handlePageChange, pagination }) => {
  return (
    <>
      <TableContainer
        component={Paper}
        sx={{ boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', px: 2 }}
      >
        <Table sx={{ padding: 0 }}>
          <TableHead>
            <TableRow sx={{ borderBottom: '1.5px solid #E5E7EB' }}>
              <TableCell
                sx={{
                  fontSize: 11,
                  color: palette.primary.tableHeadTitle,
                  fontFamily: 'poppinsThin',
                  pl: 0,
                  minWidth: { xs: 220, md: 150, lg: 140 }
                }}
              >
                File Name
              </TableCell>
              <TableCell
                sx={{
                  fontSize: 12,
                  color: palette.primary.tableHeadTitle,
                  fontFamily: 'poppinsThin',
                  pl: 0,
                  minWidth: { xs: 150, md: 150, lg: 140 }
                }}
              >
                Uploaded Date
              </TableCell>
              <TableCell
                sx={{
                  fontSize: 12,
                  color: palette.primary.tableHeadTitle,
                  fontFamily: 'poppinsThin',
                  pl: 0,
                  minWidth: { xs: 100, md: 100, lg: 100 }
                }}
              >
                Processed Records
              </TableCell>
              <TableCell
                sx={{
                  fontSize: 12,
                  color: palette.primary.tableHeadTitle,
                  fontFamily: 'poppinsThin',
                  pl: 0,
                  minWidth: { xs: 100, md: 150, lg: 140 }
                }}
              >
                Status
              </TableCell>
            </TableRow>
          </TableHead>
          {!loading && (
            <TableBody>
              {data.map((row) => (
                <TableRow key={row.id} sx={{ borderBottom: '1.5px solid #E5E7EB' }}>
                  <TableCell
                    sx={{
                      fontSize: 12,
                      fontFamily: 'poppinsMedium',
                      pl: 0
                    }}
                  >
                    {row?.file_name || 'N/A'}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: 12,
                      fontFamily: 'poppinsMedium',
                      pl: 0
                    }}
                  >
                    {row?.date || 'N/A'}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: 12,
                      fontFamily: 'poppinsMedium',
                      pl: 0
                    }}
                  >
                    {row?.processed_records || 'N/A'}
                  </TableCell>
                  <TableCell
                    sx={{
                      pl: 0
                    }}
                  >
                    <Typography
                      sx={{ fontFamily: 'poppinsLight' }}
                      className={
                        (row?.status?.toLowerCase() == 'completed' && 'status-green') ||
                        (row?.status?.toLowerCase() == 'processing' && 'status-pending')
                      }
                    >
                      {row?.status || 'N/A'}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}

          {/* loader */}
          {loading && (
            <TableBody>
              <TableRow>
                <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                  <CircularProgress />
                </TableCell>
              </TableRow>
            </TableBody>
          )}

          {/* empty list */}
          {data.length == 0 && !loading && <TableNoData colSpan={7} />}
        </Table>

        {/* PAGINATION */}
        {!loading && pagination.last_page > 1 && data.length !== 0 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 10,
              alignItems: 'center'
            }}
            my={1}
            px={2}
          >
            <Pagination
              count={pagination.last_page}
              page={pagination.current_page}
              onChange={handlePageChange}
              color="primary"
            />
          </Box>
        )}
      </TableContainer>
    </>
  );
};

export default UploadListTable;
